import { render, staticRenderFns } from "./ResourcesParent.vue?vue&type=template&id=8b9b7b2c"
import script from "./ResourcesParent.vue?vue&type=script&lang=js"
export * from "./ResourcesParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports